import { ACCOUNT_ROUTE, INTEGRATIONS_ROUTE, NEW_CHANGE_ORGANIZATION_ROUTE } from './auth';
import {
  SECTION_ACCOUNT,
  SECTION_EXIT,
  SECTION_INTEGRATIONS,
  SECTION_LANGUAGE,
  SECTION_ORGANIZATION
} from './tagManager';
import { IMenuPosition } from '../components/StyledMenu/StyledMenu';
import { ICompanyData } from '../interfaces/businessData';
import { IRowStatus } from '../interfaces/collaboratorRow';
import { IProfileMenuItem } from '../interfaces/global';
import { TRANSLATIONS_GLOBAL } from '../translations/commons';
import { TagTypes } from '../types/types';

export const USE_MOCKS = process.env.VITE_USE_MOCKS === 'true' || false;

export const RECAPTCHA_SITE_KEY = process.env.VITE_RECAPTCHA_SITE_KEY;

export const HIDE_ROW_STATE: IRowStatus = {
  state: 'hide-row',
  plusClass: 'show',
  minusClass: 'hide'
};

export const SHOW_ROW_STATE: IRowStatus = {
  state: 'active-row',
  plusClass: 'hide',
  minusClass: 'show'
};

export const MAX_SLIDES_TO_SHOW = 3;

export const SHOW_ASSET_MODAL = true;
export const IS_DEV = process.env.VITE_ENV_SHORTNAME === 'dev';
export const IS_STG = process.env.VITE_ENV_SHORTNAME === 'stg';

export const SI_PREFIXES = ['', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];

export const LOADING_TABLE_ROWS = 5;
export const LOADING_TABLE_ROWS_V3 = 5;

export const DATA_SIZE_BASE: { [type in 'decimal' | 'binary']: number } = {
  decimal: 1000,
  binary: 1024
};

export const ANCHOR_ORIGIN_LEFT_RIGHT: IMenuPosition = {
  vertical: 'bottom',
  horizontal: 'left'
};

export const TRANSFORM_ORIGIN_LEFT_RIGHT: IMenuPosition = {
  vertical: 'top',
  horizontal: 'left'
};

export const MENU_DIRECTION_RIGHT = {
  anchor: ANCHOR_ORIGIN_LEFT_RIGHT,
  transform: TRANSFORM_ORIGIN_LEFT_RIGHT
};

export const SELECTED_COMPANY = 'selectedCompany';
export const SELECTED_HOLDING = 'selectedHolding';
export const LAST_SHOWN_PENDING_MEMBERS = 'lastShownPendingMembers';

export const DEFAULT_COMPANY = { id: '', name: '', countryCode: '', role: { name: 'default', permissions: [] } };

export const DEFAULT_HOLDING = {
  id: -1,
  name: '',
  fullAccess: false,
  companies: [],
  mergeIntegration: false,
  hasPendingMembers: false
};

export const DEFAULT_DATA_ORIGIN = 'company';

export const DEFAULT_COMPANY_LOCALE = 'es-CL';

export const DEFAULT_COMPANY_CLUSTER = 'eager';

export const DEFAULT_COMPANY_GROUP = 'micro';

export const DEFAULT_COMPANY_DATA: ICompanyData = {
  id: '',
  name: '',
  additionalInfo: {},
  locale: DEFAULT_COMPANY_LOCALE,
  clusterType: DEFAULT_COMPANY_CLUSTER,
  companyGroup: DEFAULT_COMPANY_GROUP,
  keyCompany: false,
  countryCode: '',
  planId: '1',
  plans: [
    {
      id: 1,
      name: 'Plan 1',
      description: null,
      commercialPlanId: null,
      price: 0.0,
      currency: 'UF',
      countryCode: 'CL',
      summary: {},
      benefits: [],
      isNewExperience: true,
      status: 'active'
    },
    {
      id: 2,
      name: 'Plan 2',
      description: null,
      commercialPlanId: null,
      price: 0.0,
      currency: 'UF',
      countryCode: 'CL',
      summary: {},
      benefits: [],
      isNewExperience: true,
      status: 'active'
    }
  ]
} as ICompanyData;

export const CARD_STATUS = {
  success: 'success',
  error: 'error',
  informative: 'informative',
  alert: 'alert'
};

export const BOX_STATUS = {
  success: 'success',
  error: 'error',
  informative: 'informative',
  alert: 'alert'
};

export const TAG_TYPES: { [key: string]: TagTypes } = {
  success: 'success',
  error: 'error',
  informative: 'informative',
  alert: 'alert',
  neutral: 'neutral'
};

export const FONT_ROBOTO = 'Roboto';
export const FONT_OBVIOUSLY = 'Obviously';
export const FONT_SIZE_16 = '16px';
export const FONT_SIZE_14 = '14px';
export const FONT_WEIGHT_400 = 400;
export const FONT_WEIGHT_700 = 700;

export const POSITION_LEFT = 'left';
export const POSITION_RIGHT = 'right';

export const BUCKET_URL_BASE_DEV = 'https://static.techbetterfly.com/b2b';
export const BUCKET_URL_BASE_PROD = 'https://static.gobetterfly.com/b2b';

export const IS_NOT_LOCAL = process.env.VITE_ENV_SHORTNAME !== 'local';

export const CLIENTS_PORTAL_URL = process.env.VITE_FRONT_URL ?? '';
export const WALLET_PORTAL_URL = process.env.VITE_WALLET_URL ?? '';

export const AMPLIFY_COOKIES_KEY_START = 'CognitoIdentityServiceProvider';
export const AMPLIFY_COOKIES_KEY_END_ACCES_TOKEN = 'accessToken';

export const TABLET_SCREEN_SIZE = 834;
export const BETTERFLY_DOMAIN = '@betterfly.com';
export const GOBETTERFLY_DOMAIN = '@gobetterfly.com';

export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
export const DOMAIN_REGEX = /^@[a-zA-Z\d]+(?:\.[a-zA-Z\d-]+)*\.[a-zA-Z]{2,}/;
export const ONLY_NUMBERS_REGEX = /^\d*$/;

export const NOT_ALLOWED_DOMAINS = [
  'hotmail',
  'gmail',
  'yahoo',
  'mail',
  'mailbox',
  'outlook',
  'live',
  'msn',
  'aol',
  'icloud',
  'me',
  'mac',
  'gmx',
  'yandex',
  'zoho',
  'protonmail',
  'tutan'
];

export const GOOGLE_CALENDAR_URL =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ10HaT_n1tiKreJwWHuZOGDYi2lTkA-qRn5YKAfIjj-LrxH3KTJPTRgmdI3I2oh1e-Z1_oPy_eX?gv=true';

export const SLACK_OAUTH_URL =
  'https://slack.com/oauth/v2/authorize?client_id=493331556215.6020677785189&scope=chat:write,users:read,users:read.email,users:write&redirect_uri=';

export const DEFAULT_PAGINATOR_STATE = 15;
export const DEFAULT_PAGINATOR_OPTIONS = [15, 25, 50];

export const DEFAULT_PAGINATOR_COLLABORATORS_VALUE = 50;
export const DEFAULT_PAGINATOR_STATE_V3 = 150;
export const DEFAULT_PAGINATOR_OPTIONS_V3 = [50, 100, 150];

export const EXCEL_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const PROFILE_MENU_ITEMS: IProfileMenuItem[] = [
  { name: TRANSLATIONS_GLOBAL.header.profileMenu.account, route: ACCOUNT_ROUTE, gtmSection: SECTION_ACCOUNT },
  {
    name: TRANSLATIONS_GLOBAL.header.profileMenu.organization,
    route: NEW_CHANGE_ORGANIZATION_ROUTE,
    gtmSection: SECTION_ORGANIZATION
  },
  {
    name: TRANSLATIONS_GLOBAL.header.profileMenu.integrations,
    route: INTEGRATIONS_ROUTE,
    gtmSection: SECTION_INTEGRATIONS
  },
  { name: TRANSLATIONS_GLOBAL.header.profileMenu.language, route: ACCOUNT_ROUTE, gtmSection: SECTION_LANGUAGE },
  { name: TRANSLATIONS_GLOBAL.header.profileMenu.logout, route: 'logout', gtmSection: SECTION_EXIT }
];

export const SEVENTY_TWO_HOURS_IN_MS = 72 * 60 * 60 * 1000;

export const COUNTRY_CODE_SPAIN = 'es';
export const COUNTRY_CODE_MEXICO = 'mx';
export const COUNTRY_CODE_US = 'us';

export const DATE_DDMMYYYY_REGEX = /^(\d{2})-(\d{2})-(\d{4})$/;
